import type { SvgIconProps } from '@mui/material/SvgIcon';
import type { SxProps, Theme } from '@mui/material/styles';
import type { ComponentType } from 'react';
import { useEffect, useState } from 'react';

import WrenchIcon from './Wrench';
import { getCachedMaterialIcon, loadMaterialIcon } from './materialIconRegistry';

type Props = SvgIconProps & {
  iconId: string;
  sx?: SxProps<Theme>;
};

export default function MaterialIcon({ iconId, sx, ...props }: Props) {
  const [ResolvedIcon, setResolvedIcon] = useState<ComponentType<SvgIconProps> | null>(
    () => getCachedMaterialIcon(iconId) ?? null,
  );

  useEffect(() => {
    const cached = getCachedMaterialIcon(iconId);
    if (cached) {
      setResolvedIcon(() => cached);
      return;
    }

    let cancelled = false;

    void loadMaterialIcon(iconId).then(Loaded => {
      if (cancelled) return;
      setResolvedIcon(() => Loaded ?? WrenchIcon);
    });

    return () => {
      cancelled = true;
    };
  }, [iconId]);

  const Component = ResolvedIcon ?? WrenchIcon;
  return <Component sx={sx} {...props} />;
}
